<template lang='pug'>
  form.update-email.form.component( @submit.prevent='update' )
    bf-wrapper.max-640
      h3 {{$t("To update your email, please enter your new email and current password below")}}
      bf-divider.card
      .fields
        fieldset.span-2
          label( v-if='invalid' ) {{$t("Email is already taken")}}!
          label( v-else ) {{$t("Email")}}*
          bf-input.name.basic( :class='{ invalid: invalid }' )
            input( type='email' :placeholder='$t("Email Address")' v-model='email' )

        fieldset.field.span-2
          label {{$t("Password")}}
          bf-input.new-password.basic
            input( type='password' :placeholder='$t("Current Password")' v-model='password' )
      
      bf-divider.card

      .buttons
        bf-button( type='submit' )
          template( v-slot:text ) {{ $t('Update') }}
        bf-button.secondary( @click.native='$emit("back")' )
          template( v-slot:text ) {{ $t('Back') }}
</template>

<script>
  import { db, auth } from '@/main'

  export default {
    name: 'update-email.form',

    components: {
    },

    props: {
      user: { type: Object, required: true },
      account: { type: Object, required: true }
    },

    data() {
      return {
        invalid: false,
        email: '',
        password: ''
      }
    },

    methods: {
      update() {
        const actionSettingCode = { url: 'https://app.bluefaucet.com/' }
        auth.signInWithEmailAndPassword( auth.currentUser.email, this.password ).then( obs =>
          obs.user.updateEmail( this.email ).then( usr => {
            auth.currentUser.sendEmailVerification(actionSettingCode)
            db.collection( 'accounts' ).doc( auth.currentUser.uid ).update({ email: auth.currentUser.email }).then( () => 
              this.$emit( 'updated' )
            )
          }).catch( e => {
            this.invalid = true
            this.message = e.message
          })
        ).catch( e => this.message = e.message )
      }
    }
  }
</script>

<style scoped lang="stylus">
  .update-email
    .fields
      display grid
      grid-template-columns repeat( auto-fill, minmax( 240px, 1fr ) )
      grid-gap 32px
    fieldset
      margin 32px 0
      .bf-input
        margin-top 8px
    .buttons
      text-align center
      button[type=submit]
        margin-right 24px
</style>
